import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EnableDisableModel } from 'src/app/models/Settings/approval-workflow.model';
import { PlatformService } from 'src/app/services/platformbase.service';
import { SettingsService } from 'src/app/services/settings-services';

@Component({
  selector: 'app-financial-workflow',
  templateUrl: './financial-workflow.component.html',
  styleUrls: ['./financial-workflow.component.scss'],
})
export class FinancialWorkflowComponent implements OnInit {
  platformType: number;
  // workflowForm: FormGroup;
  buttonDisabled: boolean = false;
  showLoader: boolean = true;
  showTable: boolean = false;
  loadersList = [1, 2, 3, 4];
  userInfo: any;
  status: Array<number> = [];
  currentPage = 0;
  pageSize = 25;
  selectedIndex: any = -1;
  displayedColumns: any[] = ['servicetype', 'workflowname', 'description', 'status', 'disablestatus'];
  dataSource: MatTableDataSource<any>;
  tableDataList: any;
  statusDisable: boolean = false;
  approvals = [
    { 'productName': 'Report', 'workflowName': "Milage", 'workflowDesc': "Report created", "status": 1 },
    { 'productName': 'Advance', 'workflowName': "amount", 'workflowDesc': "Advance created", "status": 2 }
  ]
  selectedLegalEntity: any;
  requestBody: { legalEntityId: any; legalEntityGUID: any; type: any };
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  showingStatus: boolean = false;
  approvalObj: any;
  statusFlag: any;
  modalRef: BsModalRef;
  statusMessage: string;
  isApicallinProgress: boolean = false;
  pageNumber: number = 1;
  PageLimit: number[] = [5, 10, 25, 100];
  typeStr: any;
  paginatorStatus:boolean = false;
  financeWorkflowList:any;

  constructor(private platformService: PlatformService, private modalService: BsModalService,
    private title: Title, private router: NavController, private settingsService: SettingsService

  ) { }

  ngOnInit() {
    this.typeStr = parseInt(sessionStorage.getItem('typeStr'));
  }

  ionViewWillEnter() {
    this.platformType = this.platformService.getPlatformType();
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let applicationTitle = this.userInfo.applicationTitle;
    if(applicationTitle){
        this.title.setTitle('Finance Workflow| Settings');
    }else{ 
      this.title.setTitle("Finance Workflow| Settings");
    }
    this.getApprovalFlow();


  }
  addNewFlow() {
    this.router.navigateRoot(['/settings/financialworkflow/add'])

  }
  navigateToEditWorkFlow(data) {
    this.router.navigateRoot(['/settings/financialworkflow/update', data.categoryId, data.categoryGUID]);
  }

  getApprovalFlow() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.selectedLegalEntity = JSON.parse(sessionStorage.getItem('selectedLegalEntity'));
    // this.requestBody = {
    //   "legalEntityId": this.selectedLegalEntity.legalEntityId,
    //   "legalEntityGUID": this.selectedLegalEntity.legalEntityGuId,
    //   "type": this.typeStr,
    //   "pageNumber": this.pageNumber,
    //   "pageSize": this.pageSize
    // };
    let requestBody = {
      legalEntityId:this.selectedLegalEntity.legalEntityId,
      legalEntityGUID: this.selectedLegalEntity.legalEntityGuId,
      type: this.typeStr,
      pageNumber:this.pageNumber,
      pageSize: this.pageSize
    }
    this.settingsService.getApprovalWorkflows(requestBody).subscribe(data => {
      if (data.payload.length > 0) {
        // this.dataSource = new MatTableDataSource(data.payload);
        // this.dataSource.paginator = this.paginator;
        // this.dataSource.sort = this.sort;
        data.payload.forEach((value, index) => {
          this.status[index] = value.statusId;
        });
        if(this.paginatorStatus){
          let listitems = data?.payload;
          listitems.forEach(element => {this.financeWorkflowList.push(element);});
          this.dataSource = new MatTableDataSource(this.financeWorkflowList);
          this.dataSource.paginator = this.paginator;
          this.tableDataList = this.financeWorkflowList;
        }else{
          this.financeWorkflowList = data?.payload;
          this.dataSource = new MatTableDataSource(this.financeWorkflowList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.tableDataList = this.financeWorkflowList;

          if(this.pageNumber == 1){
            this.paginatorStatus = true;
            this.pageNumber++;
            this.getApprovalFlow();
          }
        }
        this.pageNumber != 2 ? this.paginatorStatus = false : '';

        this.showLoader = false;
        this.showTable = true;
        this.isApicallinProgress = false;
      } else {
        this.showLoader = false;
        this.showTable = true;
        this.financeWorkflowList.length != 0 ? this.tableDataList = this.financeWorkflowList : this.tableDataList = null;
      }
    });
  }

  hideDropdown() {
    if (this.selectedIndex !== -1) {
      this.selectedIndex = -1;
    }
  }

  navigateToUpdateWorkflow(row: any) {
    this.router.navigateRoot(['/settings/financialworkflow/update', row.approvalWorkflowId, row.approvalWorkflowGUID, row.statusId])
  }
  toggleStatusDropdown(index) {
    if (this.selectedIndex != index)
      this.selectedIndex = index;
    else
      this.selectedIndex = -1;
  }

  handlePage(e) {
    this.currentPage = e.pageIndex;
    // this.pageSize = e.pageSize;
    if(!this.dataSource.paginator.hasNextPage()){
      this.paginatorStatus = true;
      this.pageNumber++;
      this.getApprovalFlow();
    }
  }

  loadMore(event) {
    if (!this.isApicallinProgress) {
      if (this.tableDataList.length < this.pageSize && event) {
        event.target.disabled = true;
      } else {
        this.pageNumber++;
        this.getApprovalFlow();
      }
    }
  }

  toggleStatus(data, content) {
    this.approvalObj = data;
    this.modalRef = this.modalService.show(content, { class: 'modal-md modal-dialog-centered' });
    switch (this.approvalObj.statusId) {
      case 1: this.statusMessage = "Are you sure you want to disable Approval?";
        break;
      case 2: this.statusMessage = "Are you sure you want to enable Approval?";
        break;
    }
    this.hideDropdown();
  }
  enableDisableModel = new EnableDisableModel();
  statusAction() {
    this.statusDisable = true;
    this.showingStatus = true;
    this.enableDisableModel.approvalWorkflowId = this.approvalObj.approvalWorkflowId;
    this.enableDisableModel.approvalWorkflowGUID = this.approvalObj.approvalWorkflowGUID;
    this.selectedIndex = -1;
    this.enableDisableModel.type = this.typeStr;

    if (this.approvalObj.statusId == 2) {
      this.settingsService.enableApproval(JSON.stringify(this.enableDisableModel)).subscribe(data => {
        if (data.errorCode == 0) {
          this.approvalObj.statusId = 1;
          this.showingStatus = false;
          this.closeWindow();
          this.statusDisable = false;
        } else {
          this.showingStatus = false;
          this.closeWindow();
        }
      });
    } else {

      this.settingsService.disableApproval(JSON.stringify(this.enableDisableModel)).subscribe(data => {
        if (data.errorCode == 0) {
          this.approvalObj.statusId = 2;
          this.closeWindow();
          this.showingStatus = false;
        } else {
          this.closeWindow();
          this.showingStatus = false;
        }
      });

    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.financeWorkflowList =this.dataSource.filteredData;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  closeWindow() {
    this.modalRef.hide();
  }
}
